import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { SEO } from './components/SEO' // Add this import
import { NavigationContext } from './NavigationContext'
import Navigation from './Navigation'
import SinglePublication from './components/SinglePublication'
import Publikationen from './components/Publikationen'
import Aktuelles from './components/Aktuelles'
import SingleTextImRaum from './components/SingleTextImRaum'
import TextImRaum from './components/TextImRaum'
import Workshop from './components/Workshop'
import PageContent from './components/PageContent'
import Vita from './components/Vita'
import Kontakt from './components/Kontakt'
import Marquee from './components/Marquee'
function App() {
  const { currentSlug } = useContext(NavigationContext)
  
  return (
    <>
      <SEO currentSlug={currentSlug} />
      <Navigation />
      {(currentSlug === 'front-page' || currentSlug === '') && <Marquee />}
      <Routes>
        <Route path="/publikationen/:slug" element={<SinglePublication />} />
        <Route path="/publikationen" element={<Publikationen />} />
        <Route path="/aktuelles" element={<Aktuelles />} />
        <Route path="/text-im-raum/:slug" element={<SingleTextImRaum />} />
        <Route path="/text-im-raum" element={<TextImRaum />} />
        <Route path="/workshops" element={<Workshop />} />
        <Route path="/vita" element={<Vita />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/" element={<PageContent />} />
      </Routes>
    </>
  )
}export default App

